import { render } from "./FormBtn.vue?vue&type=template&id=57193bde"
import script from "./FormBtn.vue?vue&type=script&lang=js"
export * from "./FormBtn.vue?vue&type=script&lang=js"

import "./FormBtn.vue?vue&type=style&index=0&id=57193bde&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__